import { render, staticRenderFns } from "./CreateQuestionTemplate.vue?vue&type=template&id=266ee3db&lang=pug"
import script from "./CreateQuestionTemplate.vue?vue&type=script&lang=js"
export * from "./CreateQuestionTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports